import actions from '@/store/modules/setting/actions.js'
import mutations from '@/store/modules/setting/mutations.js'
import getters from '@/store/modules/setting/getters.js'
import {base_state} from '@/store/modules/base/state.js'

const state = {
  ...base_state,
  'api_module': 'setting'
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}